module.exports = __webpack_public_path__ + "static/media/footerBGL.94cdb013.png";